import { bpErrorsCodes } from 'activate-errors';

export type MarkAsBilledError =
  | { kind: 'NOT_ISSUED' }
  | { kind: 'UNKNOWN'; message: string };

export function mapMarkAsBilledError(err: unknown): MarkAsBilledError {
  const message = err instanceof Error ? err.message : '';

  if (message.includes(bpErrorsCodes.invoiceNotIssued.code)) {
    return { kind: 'NOT_ISSUED' };
  }

  return { kind: 'UNKNOWN', message };
}
